// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollnav-root {
  position: fixed;
  right: 20px;
  bottom: 90px;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Main floating button */
.scrollnav-top-btn {
  background: linear-gradient(135deg, #ff7a59, #ff3d77);
  border-radius: 50%;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  animation: fadeIn 0.4s ease;
  opacity: 0.55;
}

/* Hover + Active */
.scrollnav-top-btn:hover {
  transform: translateY(-6px) scale(1.05);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.3);
  opacity: 1;
}

.scrollnav-top-btn:active {
  transform: scale(0.95);
}

/* Focus (Accessibility) */
.scrollnav-top-btn:focus {
  outline: 3px solid rgba(255, 122, 89, 0.5);
  outline-offset: 4px;
}

/* Icon Styling */
.scrollnav-top-btn .icon {
  width: 20px;
  height: 20px;
  color: #fff;
}

/* Smooth entry */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/ScrollNav/ScrollNav.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,qDAAqD;EACrD,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,2BAA2B;EAC3B,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF","sourcesContent":[".scrollnav-root {\n  position: fixed;\n  right: 20px;\n  bottom: 90px;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Main floating button */\n.scrollnav-top-btn {\n  background: linear-gradient(135deg, #ff7a59, #ff3d77);\n  border-radius: 50%;\n  border: none;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n  animation: fadeIn 0.4s ease;\n  opacity: 0.55;\n}\n\n/* Hover + Active */\n.scrollnav-top-btn:hover {\n  transform: translateY(-6px) scale(1.05);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.3);\n  opacity: 1;\n}\n\n.scrollnav-top-btn:active {\n  transform: scale(0.95);\n}\n\n/* Focus (Accessibility) */\n.scrollnav-top-btn:focus {\n  outline: 3px solid rgba(255, 122, 89, 0.5);\n  outline-offset: 4px;\n}\n\n/* Icon Styling */\n.scrollnav-top-btn .icon {\n  width: 20px;\n  height: 20px;\n  color: #fff;\n}\n\n/* Smooth entry */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
